module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "bell-chart"
  }, [_c('svg', {
    ref: "svg",
    attrs: {
      "height": _vm.height,
      "width": _vm.width
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1741646e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/BellChart.vue
// module id = 1586
// module chunks = 0